<template>
    <div class="question-trees">
        <p class="nav-title">{{ $t("zhiji.knowlege.FAQ") }} <GameInfo class="game-info" /></p>
        <div class="tree-search-input">
            <ConditionSearch
                :resData="resData"
                @conditionInputChange="conditionInputChange"
                @showSearchList="showSearchList"
                :hasInput="hasInput"
                :placeholder="sceneHolder"
                @searchInputChange="conditionInputChange"
            ></ConditionSearch>
        </div>
        <EditTree
            class="trees-container"
            :datas="treeData"
            :editable="true"
            :maxLevel="3"
            :current="currentUrl"
            @nodeSelected="treeSelect"
            @nodeExpanded="treeExpand"
            @nodeOperate="treeOperate"
        />
    </div>
</template>

<script>
import ConditionSearch from "@/views/zhiji/bComponents/inputs/ConditionSearch";
import EditTree from "@/views/zhiji/bComponents/trees/EditTree";
import AddClassification from "./AddClassification";
import GameInfo from "@/views/zhiji/components/gameInfo/GameInfo";
import { filterTreeData, updataTreeData, getParentTree } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "QuestionTrees",
    components: {
        ConditionSearch,
        EditTree,
        GameInfo
    },
    data() {
        return {
            resData: [],
            hasInput: false,
            currentUrl: ""
        };
    },
    computed: {
        treeData() {
            return this.$store.state.zhiji.questionListPage.treeData;
        },
        sceneHolder() {
            return this.$t("zhiji.knowlege.sceneSearch");
        }
    },
    watch: {
        // 监控中英文切换，重新从后台取对应语言数据
        sceneHolder() {
            this.$store.dispatch("zhiji/getTreesData");
        }
    },
    mounted() {
        this.$store.dispatch("zhiji/getTreesData");
    },
    methods: {
        showSearchList(data) {
            this.resData = filterTreeData(this.treeData.children, data.searchInfo);
        },
        conditionInputChange(data) {
            let result = getParentTree(this.treeData.children, data.keywords);
            this.currentUrl = result.path;
        },
        treeSelect(data) {
            if (data.isRoot) {
                this.$store.dispatch("zhiji/getTreesData");
                this.$store.dispatch("zhiji/queryQuestionList", { classId: "", page: 1 });
                this.$store.dispatch("zhiji/queryExtQuestionTotal", { classId: "", page: 1 });
                this.$store.dispatch("zhiji/queryAnswersTotal", { classId: "", page: 1 });
            } else if (this.treeData.children) {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    this.$store.dispatch("zhiji/queryQuestionList", { classId: parseInt(treeData.id), page: 1 });
                    this.$store.dispatch("zhiji/queryExtQuestionTotal", { classId: parseInt(treeData.id), page: 1 });
                    this.$store.dispatch("zhiji/queryAnswersTotal", { classId: parseInt(treeData.id), page: 1 });
                });
            }
            this.$emit("selectClick", data);
        },
        treeExpand() {},
        treeOperate(data) {
            if (data.opr === "edit") {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    treeData.label = data.newLabel;
                    this.$store.dispatch("zhiji/updateQuestionTrees", treeData);
                });
            }

            if (data.opr === "delete") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.common.deleteConfim") + data.label + "？",
                        confirm: () => {
                            updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                                this.$store.dispatch("zhiji/deleteQuestionTrees", treeData);
                            });
                        }
                    }
                });
            }

            if (data.opr === "add") {
                this.$store.dispatch("zhiji/showModal", {
                    type: AddClassification,
                    data: data
                });
            }

            if (data.opr === "transfer") {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    this.$store.dispatch("zhiji/moveQuestionTrees", {
                        classId: treeData.id,
                        order: data.newIdx
                    });
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.question-trees {
    width: 272px;
    padding: 12px 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-right: 1px solid #e3ecf5;
    background: #f2f7fd;
    overflow-x: hidden;
    overflow-y: auto;

    .nav-title {
        margin: 0 8px 10px 15px;
        font-size: 14px;
        position: relative;
        font-weight: bold;
        .game-info {
            position: absolute;
            right: 0px;
            top: 0px;
            width: 248px;
        }
    }
    .tree-search-input {
        margin: 0 10px 10px 16px;
        position: relative;
    }
    .trees-container {
        height: calc(100% - 84px);
    }
}
</style>
